import script from "./AppAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAlerts.vue?vue&type=script&setup=true&lang=js"

import "./AppAlerts.vue?vue&type=style&index=0&id=14f7e890&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f7e890"]])

export default __exports__